module.exports = __webpack_public_path__ + "img/pt-logo.af1f584c.png";